/*$AMPERSAND_VERSION*/
var Events = require('ampersand-events');
var toArray = require('lodash/toArray');
var extend = require('lodash/assign');


// instance app, can be used just by itself
// or by calling as function to pass labels
// by attaching all instances to this, we can
// avoid globals
var app = {
    extend: function () {
        var args = toArray(arguments);
        args.unshift(this);
        return extend.apply(null, args);
    },
    reset: function () {
        // clear all events
        this.off();
        // remove all but main two methods
        for (var item in this) {
            if (item !== 'extend' && item !== 'reset') {
                delete this[item];
            }
        }
        // remix events
        Events.createEmitter(this);
    }
};

Events.createEmitter(app);

// export our singleton
module.exports = app;
